import React, { useState } from 'react'
import { Button, InputGroup, InputLeftAddon } from '@chakra-ui/core'

import dayjs from 'dayjs'
import { setRemoteCall } from '../../../remote'
import { getGlobalState } from '../../../store'

const ChangeDates = (props) => {
  const { data, relataion, column, setView, setOpen } = props
  const [startDate, setStartDate] = useState(data.startDate || '')
  const [endDate, setEndDate] = useState(data.endDate || '')

  const updateHistory = () => {
    try {
      if (relataion) {
        // Here you can make your API call with the form values
        setRemoteCall(
          'updateRelationDatesForId',
          {
            id: relataion,
            startDate: startDate,
            endDate: endDate,
          },
          'Datas atualizadas'
        )
        setView(null)
        setOpen(false)
      }
    } catch (e) {
      console.error('Error updating history:', e)
    }
  }

  return (
    <>
      <InputGroup size={'sm'} mb={'0.5em'}>
        <InputLeftAddon fontSize={'.8em'} p={'6px'}>
          <i className="icons icon-minus" />{' '}
        </InputLeftAddon>
        <input
          style={{
            width: '80%',
            fontSize: '.8em',
            padding: '0.2em 0.5em',
            border: '1px solid #E2E8F0',
          }}
          textAlign={'right'}
          value={dayjs(endDate)?.format('YYYY-MM-DD') || ''}
          onChange={(e) => setEndDate(e.target.value)}
          type="date"
        />
      </InputGroup>
      <InputGroup size={'sm'}>
        <InputLeftAddon fontSize={'.8em'} p={'6px'}>
          <i className="icons icon-clock" />{' '}
        </InputLeftAddon>
        <input
          style={{
            width: '80%',
            fontSize: '.8em',
            padding: '0.2em 0.5em',
            border: '1px solid #E2E8F0',
          }}
          textAlign={'right'}
          value={dayjs(startDate)?.format('YYYY-MM-DD') || ''}
          onChange={(e) => setStartDate(e.target.value)}
          type="date"
        />
      </InputGroup>

      <Button
        size="sm"
        w={'100%'}
        mt={2}
        onClick={() => updateHistory()}
        className="actionsButton"
        variantColor="red"
        variant="outline"
      >
        <i className="icons icon-share-alt" style={{ marginRight: '4px' }} />
        Atualizar datas
      </Button>
      <Button
        w={'100%'}
        size="sm"
        fontSize={'.8em'}
        onClick={() => setView(null)}
        variant="outline"
      >
        Cancelar
      </Button>
    </>
  )
}

export default ChangeDates
